"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AttributionBlock;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
/* eslint-disable no-nested-ternary */

const AttributionText = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "AttributionText",
  class: "core-a15j6n0l",
  vars: {
    "a15j6n0l-0": [({
      isBasic
    }) => isBasic ? 'initial' : 'absolute'],
    "a15j6n0l-1": [({
      isBasic
    }) => isBasic ? 'initial' : _patternLibraryUtils.density['1']],
    "a15j6n0l-2": [({
      isBasic,
      attributionPosition
    }) => isBasic ? 'initial' : attributionPosition === 'bottom-left' ? 'start' : 'end'],
    "a15j6n0l-3": [({
      attributionPosition
    }) => attributionPosition === 'bottom-left' ? '0' : 'unset'],
    "a15j6n0l-4": [({
      attributionPosition
    }) => attributionPosition === 'bottom-right' ? '0' : 'unset'],
    "a15j6n0l-5": [({
      isBasic,
      hideOnMobile
    }) => isBasic ? 'block' : hideOnMobile ? 'none' : 'inherit'],
    "a15j6n0l-7": [({
      isBasic
    }) => isBasic ? 'block' : 'inherit']
  }
});
const AttributionFigcaption = /*#__PURE__*/(0, _react2.styled)("figcaption")({
  name: "AttributionFigcaption",
  class: "core-amjjfv7",
  vars: {
    "amjjfv7-0": [({
      color
    }) => color ? color : 'initial']
  }
});

/**
 * Render attribution block.
 * @module AttributionBlock
 *
 * @param {Object} props React props
 * @param {string} props.attribution Attribution text
 * @param {string} props.attributionPosition Attribution text position
 * @param {boolean} props.hideOnMobile Hide on mobile boolean
 * @returns {React.ReactElement} HTML paragraph element
 * @public
 */
function AttributionBlock({
  attribution,
  attributionPosition,
  hideOnMobile = false,
  isBasic = false,
  onlyBoldLineOne = false,
  style,
  isFigcaption = false
}) {
  if (!attribution) return null;
  if (isFigcaption) {
    return /*#__PURE__*/_react.default.createElement(AttributionFigcaption, (0, _extends2.default)({
      "data-cy": "attribution-figcaption"
    }, style), (0, _patternLibraryUtils.formatAttribution)(attribution));
  }
  return /*#__PURE__*/_react.default.createElement(AttributionText, {
    attributionPosition: attributionPosition,
    hideOnMobile: hideOnMobile,
    isBasic: isBasic,
    "data-cy": "attribution-block"
  }, /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1
  }, (0, _patternLibraryUtils.formatAttribution)(attribution, onlyBoldLineOne)));
}
AttributionBlock.propTypes = {
  attribution: _propTypes.default.string,
  attributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right']),
  hideOnMobile: _propTypes.default.bool,
  isBasic: _propTypes.default.bool,
  onlyBoldLineOne: _propTypes.default.bool,
  style: _propTypes.default.object,
  isFigcaption: _propTypes.default.bool
};